import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { ManageGroupsComponent } from './manage-groups/manage-groups.component';


const routes: Routes = [
  {
    path: 'myclassroom',
    children: [
      { path: '', component: AppComponent},
      { path: 'managegroups', component: ManageGroupsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
